import Swiper from 'swiper';

export function initContentRegister(query = document.querySelectorAll('.js-contentRegister')) {
    for (const el of query) {
        if (el.dataset.contentRegisterInit) {
            continue;
        }
        el.dataset.contentRegisterInit = "true";

        const wrapper = el.closest('.contentRegister');
        const navItems = wrapper
            ? Array.from(wrapper.querySelectorAll('.contentRegister__navItem'))
            : [];

        const swiper = new Swiper(el, {
            slidesPerView: 1,
            speed: 400,
            on: {
                slideChange(sw) {
                    navItems.forEach((item, i) => item.classList.toggle('is-active', i === sw.activeIndex));
                }
            }
        });

        navItems.forEach((item, i) => {
            item.addEventListener('click', () => swiper.slideTo(i));
        });
    }
}
